import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { NewsResponse } from './news.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as NewsActions from './news.actions';

export const NEWS_FEATURE_KEY = 'news';

export interface NewsState extends EntityState<NewsResponse> {
  news: NewsResponse | null;
  loaded: boolean;
  error?: string | null;
}

export const newsAdapter: EntityAdapter<NewsResponse> = createEntityAdapter<NewsResponse>();

export const initialNewsState: NewsState = newsAdapter.getInitialState({
  news: null,
  loaded: true,
  error: null,
});

const reducer = createReducer(
  initialNewsState,
  on(NewsActions.loadNews, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(NewsActions.loadNewsSuccess, (state, { news }) => ({
    ...state,
    news: news,
    loaded: true,
    error: null,
  })),
  on(NewsActions.loadNewsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(NewsActions.setNewsSeenFlag, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(NewsActions.setNewsSeenFlagSuccess, (state, { response }) => ({
    ...state,
    loaded: true,
    error: null,
    news: state.news
      ? {
          ...state.news,
          [response.type]: {
            ...state.news[response.type],
            seen_at: response.seen_at,
          },
        }
      : state.news,
  })),
  on(NewsActions.setNewsSeenFlagFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(NewsActions.setNewsContentSeen, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(NewsActions.setNewsContentSeenSuccess, (state, { response }) => ({
    ...state,
    loaded: true,
    error: null,
    news: state.news
      ? {
          ...state.news,
          content: {
            ...state.news.content,
            categories: state.news.content.categories.map((category) =>
              category.id === response.id ? { ...category, seen: true, seen_at: response.seen_at } : category,
            ),
          },
        }
      : state.news,
  })),
  on(NewsActions.setNewsContentSeenFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
);

export function newsReducer(state: NewsState | undefined, action: Action) {
  return reducer(state, action);
}
